import {
    deleteMessages,
    fetchActionUpdatedMessages,
} from './message-center-actions';

const messageCenterSockets = [
    {
        eventType: 'MessageCenterActionRequiredItemsUpdated',
        actions: [data => fetchActionUpdatedMessages(data)],
    },
    {
        eventType: 'MessageCenterActionRequiredItemsDismissed',
        actions: [data => deleteMessages(data)],
    },
    {
        eventType: 'MessageCenterActionRequiredItemsDeleted',
        actions: [data => deleteMessages(data)],
    },
];

export default messageCenterSockets;
